import { render } from "./RequestHome.vue?vue&type=template&id=47b23948&scoped=true"
import script from "./RequestHome.vue?vue&type=script&lang=js"
export * from "./RequestHome.vue?vue&type=script&lang=js"

import "./RequestHome.vue?vue&type=style&index=0&id=47b23948&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b23948"]])

export default __exports__